<template>
  <div class="d-flex align-center py-2 nomination-radio-row">
    <div class="cast-name text-body-1">
      {{ cast.name || `cast#${cast.id}` }}
    </div>

    <!-- フリーバック: フリー客が指名客に移行した指名として記録。指名を選択すると押せる -->
    <v-btn
      small
      depressed
      :outlined="!freeBack"
      :disabled="!hasSelection"
      :class="['free-back-btn', 'mr-3', { 'free-back-btn--on': freeBack }]"
      title="フリーバック"
      @click="$emit('free-back-change', !freeBack)"
    >
      FB
    </v-btn>

    <div class="d-flex flex-grow-1 nomination-radio-cells">
      <v-card
        v-for="def in nominationDefs"
        :key="def.id"
        :outlined="!isSelected(def.id)"
        :color="isSelected(def.id) ? 'primary' : ''"
        :dark="isSelected(def.id)"
        :class="['nomination-card', 'flex-grow-1', { 'nomination-card--selected': isSelected(def.id) }]"
        @click="handleToggle(def)"
      >
        <v-card-text
          :class="[
            'pa-3 text-center font-weight-medium',
            isSelected(def.id) ? 'white--text' : '',
          ]"
        >
          {{ def.name }}
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'

export default {
  name: 'NominationRadioRow',
  props: {
    cast: { type: Object, required: true },
    nominationDefs: { type: Array, required: true },
    // 互換用: 単一 ID（指定された場合は単一選択モード相当）
    selectedVendibleId: { type: [Number, String], default: null },
    // 複数選択用: ID 配列。指定があればこちらを優先
    selectedVendibleIds: { type: Array, default: null },
    // フリーバック(フリー客→指名移行)としてマークされているか(キャスト行単位)
    freeBack: { type: Boolean, default: false },
  },
  emits: ['change', 'free-back-change'],
  setup(props, { emit }) {
    const selectedIds = computed(() => {
      if (Array.isArray(props.selectedVendibleIds)) {
        return props.selectedVendibleIds
      }

      // 後方互換: 単一 ID を配列化
      return props.selectedVendibleId != null ? [props.selectedVendibleId] : []
    })

    const isSelected = id => selectedIds.value.includes(id)
    const hasSelection = computed(() => selectedIds.value.length > 0)

    // クリックで個別にトグル（複数選択可）
    const handleToggle = def => {
      const currently = isSelected(def.id)
      emit('change', { vendibleId: def.id, def, selected: !currently })
    }

    return { isSelected, hasSelection, handleToggle }
  },
}
</script>

<style scoped>
.nomination-radio-row {
  border-bottom: 1px solid rgba(127, 127, 127, 0.12);
}
.nomination-radio-cells {
  display: flex;
  gap: 8px;
}
.nomination-card {
  cursor: pointer;
  min-height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cast-name {
  min-width: 120px;
  flex-shrink: 0;
}
/* FB ボタン: Vuetify の color pack が無効なため色は自前で当てる(テーマ非依存の緑) */
.free-back-btn {
  min-width: 44px !important;
  flex-shrink: 0;
  font-weight: 700;
  letter-spacing: 0.06em;
}
.free-back-btn--on {
  background-color: #4caf50 !important;
  border-color: #4caf50 !important;
  color: #fff !important;
}
</style>
